import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/img/logo.png';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

const createWidget = async (logoUrl) => {
  const widgetApiHandler = new ApiStore(WIDGET_API_URL)

  const searchParams = (new URL(document.location)).searchParams;
  const planId = searchParams.get("id");

  const planData = await widgetApiHandler.loadWidgetData(planId);
  const options = {
    ...planData.parsed,
    API_URL: WIDGET_API_URL,
    rotationMode: rotationModes.DEFAULT,
    logo: logo,
    tabs: ['panorama', 'rotation'],
    locale: 'en',
    logoUrl,
    dictionaryOverrides: {
      'made-by-text': 'Bauidee Projektplanung',
      'made-by-link': logoUrl,
      floor: '$0',
      'floorNumberEndings.1': 'Erdgeschoss',
      'floorNumberEndings.2': 'Dachgeschoss',
    },
    colors: {
      main: '#999a9c',
      mainText: '#fff'
    },
    floorNumberEndingsVisible: true,
    designType: 'standard',
    tabsButtonsDesign: 'two'
  }

  new Widget('#widget', options);
}

createWidget('https://www.bau-i.de/');
